import { inject, injectable } from 'inversify';
import { auth, doctor as store } from '@/store/modules';
import { DoctorModel } from '@/models/doctor';
import { IApiService, IDoctorService } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

export type DoctorResponse = {
  data: DoctorModel;
};

@injectable()
export default class DoctorService implements IDoctorService {
  private _api: IApiService;

  constructor(@inject(DependencyIdentifiers.ApiService) api: IApiService) {
    this._api = api;
  }

  async getMany(page: number = 1, size: number = 20): Promise<[any[], number]> {
    const res = await this._api.
      get<any>(`/doctors?size=${size}&page=${page}&filter[centerId]=${auth.currentCenterId}`);
    res.data.forEach((item: any) => store.cacheOne(item));
    return [res.data, res.meta.total];
  }

  async getById(id: string): Promise<DoctorModel> {
    const doctor = await this._api
      .get<any>(`/doctors/${id}`)
      .then(res => res.data);

    store.cacheOne(doctor);
    return doctor;
  }

  async create(data: Partial<DoctorModel>): Promise<DoctorModel> {
    const res = await this._api
      .post<DoctorResponse>(`/doctors`, { data });
    store.cacheOne(res.data);
    return res.data;
  }

  async update(id: string, data: Partial<DoctorModel>): Promise<DoctorModel> {
    const res = await this._api
      .patch<DoctorResponse>(`/doctors/${id}`, { data });
    store.cacheOne(res.data);
    return res.data;
  }
}
